export default "__VITE_ASSET__17af7dc1__"